module.exports = __webpack_public_path__ + "img/mapa-texto-satelite.8af66ac5.svg";